import { createFileRoute } from '@tanstack/react-router'

import { vehicleListSearchSchema } from '@/features/vehicles/search'
import { VehicleList } from '@/features/vehicles/vehicle-list'

export const Route = createFileRoute('/_app/vehicles/')({
  validateSearch: (search) => vehicleListSearchSchema.parse(search),
  component: VehicleList,
})
